module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-down.79681a48.svg";